/**
 * Organization Manager
 * Singleton to manage the current organization ID for API requests
 * This allows the API client to access the organization context without React hooks
 */

class OrganizationManager {
  private currentOrgId: string | null = null;
  private listeners: Set<(orgId: string | null) => void> = new Set();

  /**
   * Set the current organization ID
   */
  setOrganizationId(id: string | null) {
    if (this.currentOrgId !== id) {
      this.currentOrgId = id;
      this.notifyListeners(id);
    }
  }

  /**
   * Get the current organization ID
   */
  getOrganizationId(): string | null {
    return this.currentOrgId;
  }

  /**
   * Add a listener for organization changes
   */
  addListener(callback: (orgId: string | null) => void) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  /**
   * Notify all listeners of organization change
   */
  private notifyListeners(orgId: string | null) {
    this.listeners.forEach((callback) => callback(orgId));
  }

  /**
   * Clear the current organization
   */
  clear() {
    this.setOrganizationId(null);
  }
}

// Export singleton instance
export const organizationManager = new OrganizationManager();
export default organizationManager;
